// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2-2PEb6XBYUkBx7rZab2Bw {\n  border: none;\n  background-color: #e6e6e6;\n  color: #565756;\n  border-radius: 0.125rem; }\n\n.InnquS6yaEDAhD3OONCF0 {\n  background-color: #657281;\n  color: white; }\n\n._7sLHTn-3nHx8KqkwFhr53 {\n  background-color: transparent; }\n", ""]);
// Exports
exports.locals = {
	"defaultButtonStyling": "_2-2PEb6XBYUkBx7rZab2Bw",
	"primary": "InnquS6yaEDAhD3OONCF0",
	"tertiary": "_7sLHTn-3nHx8KqkwFhr53"
};
module.exports = exports;
